const Amenities = ({ amenities = [] }) => {
  if (!amenities.length) return null;

  return (
    <section className="max-w-7xl mx-auto p-4">
      <h2 className="text-lg font-semibold mb-4">Features & Amenities</h2>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        {amenities.map((item, i) => (
          <div
            key={i}
            className="flex items-center gap-2 bg-white p-4 rounded-lg shadow-sm text-sm"
          >
            <span className="text-green-600">✔</span>
            <span>{item}</span>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Amenities;
